"use client"

import { motion } from "framer-motion"

export function WhatsAppButton() {
  const phoneNumber = "393714425396" // номер из контактов
  const whatsappUrl = `https://wa.me/${phoneNumber}`

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-[#25D366] rounded-full shadow-lg hover:shadow-xl transition-shadow border-2 border-white"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 0, type: "spring", stiffness: 200 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      aria-label="Contact via WhatsApp"
    >
      <img
        src="/soc-icons/whatsapp-svgrepo-com.svg"
        alt="WhatsApp"
        className="w-10 h-10 rounded-full"
      />
    </motion.a>
  )
}
